import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var BaseNavUI = function BaseNavUI(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: children
  });
};
export default BaseNavUI;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "base-nav-ui___StyledDiv",
  componentId: "sc-1dowoge-0"
})({
  "display": "none",
  "width": "100%",
  "flexDirection": "row",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "1rem",
  "@media (min-width: 768px)": {
    "display": "flex"
  }
});